import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ViewportAnalytics from 'components/viewport-analytics'
import ViewportController from 'components/viewport-controller'
import { component as spContext, partnersWidget } from '@cred/react-analytics/contexts'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import WidgetContext from 'components/widget-context'

const getContexts = (
    source,
    partnerUrl,
    partnerReferrer,
    variation,
    type,
    marketplace,
    size,
    position,
    credclid,
    renderId,
    contentId,
    articleTitle,
    articleTags,
    segmentId,
  ) => {
    const spContexts = [
      partnersWidget.analytics({
        source,
        partnerUrl,
        partnerReferrer,
        widgetGeometry: { position, size },
        marketplace,
        type,
        variation,
        credclid,
        renderId,
        partnerMeta: {
          contentId,
          articleTitle,
          articleTags,
          segmentId,
        },
      }),
    ]

    return spContexts
  },
  WidgetPage = WrappedComponent => props => <HOC {...props} WrappedComponent={WrappedComponent} />,
  HOC = props => {
    const { WrappedComponent } = props,
      widgetContext = useContext(WidgetContext),
      {
        options: { ui: { theme }, product: { variation, type, marketplace }, meta: { contentId, articleTitle, articleTags, segmentId } = {}, analytics, initialValues, ...options },
        parentPage: { partnerReferrer, partnerDomain, partnerURL },
        credclid,
        renderId,
        source = analytics ? analytics.source : null,
      } = widgetContext,
      finalSource = source || partnerDomain
    let url = ''

    if (partnerURL) {
      [url] = partnerURL.split('?')
    }

    return (
      <ViewportController>
        {({ size, position, seen }) => (
          <SnowplowContext contexts={getContexts(
            finalSource,
            url,
            partnerReferrer,
            variation,
            type,
            marketplace,
            size,
            position,
            credclid,
            renderId,
            contentId,
            articleTitle,
            articleTags,
            segmentId,
          )}
          >
            <ViewportAnalytics seen={seen} position={position} size={size} />
            <WrappedComponent
              {...props}
              theme={theme}
              variation={variation}
              partnerInitialValues={initialValues}
              widgetContext={widgetContext}
              verticals={marketplace}
              utms={{
                utm_campaign: url,
                utm_medium: 'partner_integration',
                utm_source: finalSource,
                utm_content: options.uniqueId || '',
                credclid,
                renderId,
              }}
              analyticsContexts={[
                spContext.analytics({ name: `${marketplace}#${type}` }),
              ]}
            />
          </SnowplowContext>
        )}
      </ViewportController>
    )
  }

HOC.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
}

export default WidgetPage
